import { api } from "../api";
import type { ScoreResult } from "../types";
import { requireElement } from "./Hud";

export interface LeaderboardOptions {
  slug: string;
  token?: string;
  currentUserId?: string;
  /** Resultado da partida que acabou de terminar, quando houver. */
  result?: ScoreResult;
  title?: string;
}

/** Painel de recordes. Resolve quando o jogador fecha o painel. */
export function showLeaderboard(options: LeaderboardOptions): Promise<void> {
  return new Promise((resolve) => {
    const root = requireElement<HTMLDivElement>("overlay-root");
    const overlay = document.createElement("div");
    overlay.className = "overlay";
    overlay.innerHTML = `
      <div class="panel">
        <h1>${escapeHtml(options.title ?? "Placar")}</h1>
        <p class="sub" id="lb-sub">Carregando…</p>
        <div id="lb-body"><p class="empty">Carregando ranking…</p></div>
        <button type="button" class="primary" id="lb-close" style="margin-top:20px">Voltar</button>
      </div>
    `;
    root.replaceChildren(overlay);

    const close = () => {
      document.removeEventListener("keydown", onKey);
      root.replaceChildren();
      resolve();
    };
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape" || event.key === "Enter") {
        event.preventDefault();
        close();
      }
    };

    overlay.querySelector<HTMLButtonElement>("#lb-close")!.addEventListener("click", close);
    document.addEventListener("keydown", onKey);

    const sub = overlay.querySelector<HTMLParagraphElement>("#lb-sub")!;
    const body = overlay.querySelector<HTMLDivElement>("#lb-body")!;

    /** O resumo da partida vale so quando o jogador acabou de jogar esta partida. */
    const showedResult = Boolean(options.result);
    if (options.result) {
      const r = options.result;
      sub.textContent = r.isNewBest
        ? `Novo recorde pessoal: ${r.score} pontos — você está em ${r.rank}o lugar!`
        : `Você fez ${r.score} pontos. Seu recorde continua ${r.personalBest} (${r.rank}o lugar).`;
    }

    api
      .leaderboard(options.slug, options.token, 10)
      .then((data) => {
        if (!showedResult) {
          sub.textContent =
            data.personalBest !== undefined
              ? `${data.game.name} — seu recorde: ${data.personalBest}`
              : `${data.game.name} — os dez melhores da cidade`;
        }

        if (data.entries.length === 0) {
          body.innerHTML = `<p class="empty">Ninguém pontuou ainda. Seja o primeiro!</p>`;
          return;
        }

        const rows = data.entries
          .map(
            (entry) => `
            <tr class="${entry.userId === options.currentUserId ? "me" : ""}">
              <td class="rank">${entry.rank}</td>
              <td>${escapeHtml(entry.username)}</td>
              <td class="score">${entry.score}</td>
            </tr>`,
          )
          .join("");

        body.innerHTML = `
        <table class="board">
          <thead><tr><th>#</th><th>Jogador</th><th style="text-align:right">Pontos</th></tr></thead>
          <tbody>${rows}</tbody>
        </table>`;
      })
      .catch(() => {
        body.innerHTML = `<p class="empty">Não foi possível carregar o ranking agora.</p>`;
      });
  });
}

function escapeHtml(value: string): string {
  const div = document.createElement("div");
  div.textContent = value;
  return div.innerHTML;
}
